import { Component, EventEmitter, OnDestroy, OnInit, Output, Input, OnChanges, SimpleChanges, ViewChild, ElementRef } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { select, Store } from '@ngrx/store';
import {  JobOrder } from '@pos-app/data';
import { Observable, Subject } from 'rxjs';
import { debounceTime,  filter, takeUntil, tap } from 'rxjs/operators';
import { CoreUiPartialState } from '../../+state/core-ui/core-ui.reducer';
import { getJobOrders, getsearchingJobOrder} from '../../+state/core-ui/core-ui.selectors';
import {  clearSearchJobOrderData, searchJobOrder } from '../../+state/core-ui/core-ui.actions';
import { ApiService } from '../../services';


@Component({
    selector: 'pos-app-lib-order-search',
    templateUrl: './order-search.component.html',
    styleUrls: ['./order-search.component.scss'],
    standalone: false
})
export class OrderSearchComponent implements OnInit, OnDestroy, OnChanges {
  @ViewChild('searchBox') searchBox: ElementRef;
  @ViewChild('searchResult') searchResult!: ElementRef;
  @Input() placeHolder: string;
  @Output() selectedJobOrder = new EventEmitter<JobOrder>();

  unSubscribe$ = new Subject<void>();
  loading$: Observable<boolean>;
  jobOrders$: Observable<JobOrder[]>;
  hasMoreRecords: boolean;
  jobOrderSelected: JobOrder = null;
  listOfJobOrders: JobOrder[];
  defaultPlaceHolder: string = 'Search Orders in schedule';

  indexFocus = 0;
  show = false;
  jobOrderSearchForm: UntypedFormGroup;
  selectType: boolean;

  constructor(private coreUIStore: Store<CoreUiPartialState>, private fb: UntypedFormBuilder, private apiService: ApiService) {}

  ngOnInit() {
    this.coreUIStore.dispatch(clearSearchJobOrderData());
    this.jobOrderSearchForm = this.fb.group({
      jobOrderSearch: [''],
    });
    this.jobOrders$ = this.coreUIStore.pipe(select(getJobOrders));

    this.jobOrders$?.pipe(takeUntil(this.unSubscribe$)).subscribe((x) => {
      this.listOfJobOrders = x;
      const matchJobOrderNumber = this.listOfJobOrders?.find(
        (jobOrder) => jobOrder.orderNumber === this.jobOrderSearchForm.get('jobOrderSearch').value
      );
      if (matchJobOrderNumber) {
        this.selectJobOrder(matchJobOrderNumber);
      }
      this.positionSearchResult();
    });

    this.loading$ = this.coreUIStore.select(getsearchingJobOrder);

    this.onChanges();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.disabled && this.jobOrderSearchForm) {
      this.jobOrderSearchForm.get('jobOrderSearch').enable({ emitEvent: false });
      this.searchBox.nativeElement.focus();
    }
  }

  ngOnDestroy() {
    this.unSubscribe$.next();
    this.unSubscribe$.complete();
  }

  onKeyboard(e) {
    if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
      let newIdx = this.indexFocus + (e.key === 'ArrowDown' ? 1 : -1);
      newIdx = newIdx < 0 ? 0 : newIdx;
      this.indexFocus = newIdx % this.listOfJobOrders.length;
    } else if (e.key === 'Enter' && this.listOfJobOrders?.length > 0) {
      this.selectJobOrder(this.listOfJobOrders[this.indexFocus]);
    } else {
      this.show = true;
      this.positionSearchResult();
    }
  }
  lostFocus(e) {
    setTimeout(() => {
      let isMouseOnTable = document.querySelector('.searchResult:hover');

      if (!isMouseOnTable) {
        this.show = false;
        if (this.selectType) {
          this.searchBox.nativeElement.focus();
          this.selectType = false;
        }
      }
    }, 300);
  }
  selectJobOrder(jobOrder: JobOrder) {
    this.show = false;
    this.jobOrderSelected = jobOrder;
    this.selectedJobOrder.emit(this.jobOrderSelected);
    this.jobOrderSelected = null
    this.listOfJobOrders = [];
    this.coreUIStore.dispatch(clearSearchJobOrderData());
    this.jobOrderSearchForm.patchValue({ jobOrderSearch: "" }, { emitEvent: false });
  }

  onChanges() {
    this.jobOrderSearchForm
      .get('jobOrderSearch')
      .valueChanges.pipe(
        tap((value) => {
          this.jobOrderSelected = null;
          this.listOfJobOrders = [];
          this.hasMoreRecords = false;

          this.jobOrderSearchForm.patchValue({ customerSearchType: '' }, { emitEvent: false });
        }),
        debounceTime(500),
        filter((v) => (v || '').trim().length >= 3),
        takeUntil(this.unSubscribe$)
      )
      .subscribe((value: string) => {
        this.coreUIStore.dispatch(clearSearchJobOrderData());
        this.coreUIStore.dispatch(
          searchJobOrder({
            jobSearchString: value.replace('-', ''),
          })
        );
      });
  }

  isFocus(e) {
    this.show = true;
    e.target.select();
    this.positionSearchResult();
  }
  getCenterOfScreen(): { x: number; y: number } {
    const x = window.innerWidth / 2;
    const y = window.innerHeight / 2;
    return { x, y };
  }
  //position the searchResult middle point element horizontally center of the screen
  positionSearchResult() {
    if (this.listOfJobOrders?.length > 0 && this.show && this.searchResult?.nativeElement && this.searchBox?.nativeElement) {
      this.searchResult.nativeElement.style.maxHeight = `${window.innerHeight * 0.4}px`;
    }
  }
}

